module.exports = __webpack_public_path__ + "img/home__pl35——vi.b58f14b2.png";